import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, TrendingUp } from "lucide-react";
import { useNavigate } from "react-router-dom";
import TopBar from "../components/layout/TopBar";
import RecentPosts from "../components/RecentPosts";
import useApi from "../hooks/useApi";
import { useBranch } from "../context/BranchContext";

const TONE = {
  positive: { bg: "rgba(147,192,32,.1)", fg: "#678A16" },
  warning: { bg: "rgba(229,169,61,.14)", fg: "#B47A1C" },
  critical: { bg: "rgba(217,92,92,.1)", fg: "#B23B3B" },
};

export default function Insights() {
  const navigate = useNavigate();
  const { branchId } = useBranch();
  const { data } = useApi(`/insights?branch_id=${branchId}`, [branchId]);

  return (
    <>
      <TopBar />
      <div className="p-6 sm:p-8 max-w-[1200px]">
        <div className="mb-6 animate-rise">
          <h1 className="text-3xl font-extrabold tracking-tighter text-ink">Insights</h1>
          <p className="text-ink-2 mt-1">Every insight leads to an action.</p>
        </div>
        <RecentPosts />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {(data || []).map((ins, i) => {
            const t = TONE[ins.tone] || TONE.positive;
            return (
              <motion.div key={ins.id} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}
                className="card card-hover p-6" data-testid={`insight-${ins.id}`}>
                <div className="flex items-start justify-between gap-4">
                  <div className="flex items-center gap-2 rounded-full px-3 py-1.5" style={{ background: t.bg }}>
                    <TrendingUp size={14} strokeWidth={2} style={{ color: t.fg }} />
                    <span className="text-lg font-extrabold tracking-tight" style={{ color: t.fg }}>{ins.metric}</span>
                  </div>
                </div>
                <h3 className="text-lg font-bold tracking-tight text-ink mt-4">{ins.title}</h3>
                <p className="text-ink-2 mt-2 leading-relaxed">{ins.body}</p>
                <button className="mt-4 text-sm font-semibold inline-flex items-center gap-1.5 hover:gap-2 transition-all" style={{ color: "#151515" }}
                  onClick={() => navigate(`/app${ins.action_route}`)} data-testid={`insight-action-${ins.id}`}>
                  {ins.action} <ArrowRight size={14} strokeWidth={2} />
                </button>
              </motion.div>
            );
          })}
        </div>
      </div>
    </>
  );
}
